module.exports = __webpack_public_path__ + "static/media/two.1bc93de0.svg";